import { useTranslation } from "react-i18next"

const MonthsData = () => {
    const { t } = useTranslation()
    return [
        { value: "january", label: t('common.january') },
        { value: "february", label: t('common.february') },
        { value: "march", label: t('common.march') },
        { value: "april", label: t('common.april') },
        { value: "may", label: t('common.may') },
        { value: "june", label: t('common.june') },
        { value: "july", label: t('common.july') },
        { value: "august", label: t('common.august') },
        { value: "september", label: t('common.september') },
        { value: "october", label: t('common.october') },
        { value: "november", label: t('common.november') },
        { value: "december", label: t('common.december') }
    ]
}

export default MonthsData